import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { useMutation } from '@sorare/core/src/hooks/graphql/useMutation';

import type {
  FootballLoadSuggestLineupMutation,
  FootballLoadSuggestLineupMutationVariables,
} from './__generated__/useLoadSuggestLineup.graphql.ts';

const LOAD_SUGGEST_LINEUP_MUTATION = gql`
  mutation FootballLoadSuggestLineupMutation($input: loadSuggestedLineupInput!) {
    loadSuggestedLineup(input: $input) {
      so5LeaderboardContender {
        slug
        so5Lineup {
          id
        }
        managerTeam {
          id
        }
        so5Leaderboard {
          slug
          so5Fixture {
            slug
            mySo5LineupsCount
            so5LeaderboardGroups {
              slug
              so5LeagueTrackGroups {
                slug
                so5LeagueTracks {
                  slug
                  mySo5LeaderboardContenders {
                    slug
                    so5Lineup {
                      id
                    }
                  }
                }
              }
              eligibleCardsCountByPosition {
                slug
                position
                seasonality
                totalCount
                usedCardsCount
              }
            }
          }
        }
      }
      currentUser {
        slug
        forcedIntoOnboarding
        blockchainCardsInLineups
      }
      errors {
        path
        message
        code
      }
    }
  }
` as TypedDocumentNode<
  FootballLoadSuggestLineupMutation,
  FootballLoadSuggestLineupMutationVariables
>;

export const useLoadSuggestLineup = () => {
  return useMutation(LOAD_SUGGEST_LINEUP_MUTATION, {
    showErrorsWithSnackNotification: true,
  });
};
